import React from 'react';
import { Empty } from '@douyinfe/semi-ui';
import { IllustrationConstruction } from '@douyinfe/semi-illustrations';
import styles from './index.module.scss';

const UnderDevelopment = () => {
    return (
        <div className={styles.underDevelopmentContainer}>
            <Empty
                image={<IllustrationConstruction style={{ width: 150, height: 150 }} />}
                title="功能开发中"
                description="该功能正在开发中，敬请期待..."
            />
        </div>
    );
};

export default UnderDevelopment;